<template>
    <div>
        <div class="modal fade modal_center_widget" id="modal_center_widget" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header p-2 no-rounded shadow-sm" :style="styleModalHeader">
                        <h5 class="modal-title" id="exampleModalCenterTitle" v-html="title"></h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true" style="font-size: 30px;">&times;</span></button>
                    </div>
                    <div class="modal-body pb-0">
                        <slot name="content"></slot>
                    </div>
                    <div class="modal-footer p-1">
                        <slot name="footer"></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
export default {
    props: {
        open:{
            type:Boolean,
            default:false
        },
        title:String,
        styleModalHeader:Object
    },

    mounted(){
        $('.modal_center_widget').on('hidden.bs.modal', () => {
            this.$emit('close');
        })
    },
    watch: {
        open(value){
            if(value){
                $('.modal_center_widget').modal('show');
            }else{
                $('.modal_center_widget').modal('hide'); 
            }
        }
    },
}
</script>